export default "__VITE_ASSET__bCCSrUTX__"